import React from 'react';
import Skeleton from 'react-loading-skeleton';
import styles from './dashboard-stat.module.css';

/**
 * DashboardStatCard
 *
 * Props:
 *   label    — string           card title
 *   value    — string | null    formatted primary metric; null → skeleton
 *   pill     — { text, tone } | null
 *              tone: 'good' | 'bad' | 'neutral'
 *   context  — string | null    muted text after the pill
 *   loading  — boolean
 */
export const DashboardStatCard = ({ label, value, pill, context, loading = false }) => {
  const pill_cls = pill
    ? { good: styles.pillGood, bad: styles.pillBad, neutral: styles.pillNeutral }[pill.tone] ??
      styles.pillNeutral
    : null;

  return (
    <div className={styles.card}>
      <div className={styles.label}>{label}</div>
      <div className={styles.value}>
        {loading ? <Skeleton width={72} height={28} /> : value ?? '—'}
      </div>
      <div className={styles.trendRow}>
        {loading ? (
          <Skeleton width={80} height={18} borderRadius={20} />
        ) : pill ? (
          <>
            <span className={`${styles.pill} ${pill_cls}`}>{pill.text}</span>
            {context && <span className={styles.context}>{context}</span>}
          </>
        ) : context ? (
          <span className={styles.context}>{context}</span>
        ) : null}
      </div>
    </div>
  );
};
